import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const amPmTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#c01466',
    },
    secondary: {
      main: '#7030A0',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#d24e1e',
    },
  },
};
